<template>
    <div class="form-group">
        <label class="form-check-label mb-1">
            {{ label }}
            <span v-if="isHospiceLos" class="text-danger ms-1">*</span>
        </label>
        <section>
            <TypeaheadInput
                :getData="getPhysicianList"
                v-on:valueChanged="physicianChanged"
                :value="physician"
                placeholder="Start Typing..."
                :characterLimit="3"
                :disabled="disabled"
                v-on:blurredInput="emitBlur"
            />
            <div class="mt-2 card p-2" v-if="loadingPhyDetails">
                <p><span class="shimmer-loading block-size-4"></span></p>
                <p>
                    <i class="fas fa-address-book"></i>
                    <span class="shimmer-loading block-size-8"></span>
                </p>
                <p>
                    <i class="fas fa-mobile-alt"></i>
                    <span class="shimmer-loading block-size-6"></span>
                </p>
                <p>
                    <i class="fas fa-at"></i>
                    <span class="shimmer-loading block-size-4"></span>
                </p>
            </div>
            <div class="d-flex flex-column mt-2 card p-2" v-if="!loadingPhyDetails && hasData">
                <span class="font-size-base fw-bold" v-if="physicianDetails.lastName">
                    <FormatName :lastName="physicianDetails.lastName" :firstName="physicianDetails.firstName">
                    </FormatName>
                </span>
                <span class="mb-1 text-secondary d-flex" v-if="physicianDetails.npiNumber">
                    NPI: {{ physicianDetails.npiNumber }}
                    <span class="badge badge-outline-success" v-if="physicianDetails.isPecosVerified">
                        <i class="fas fa-check-circle me-1"></i>
                        PECOS
                    </span>
                    <span
                        class="badge badge-outline-danger"
                        v-tooltip="{ title: physicianDetails.pecosBadgeToolTip }"
                        v-else
                    >
                        <i class="fas fa-times-circle me-1"></i>
                        PECOS
                    </span>
                </span>
                <b>Contact Information:</b>
                <span class="d-flex">
                    <span class="me-1">{{ physicianDetails.address.addressLine1 }},</span>
                    <span class="me-1" v-if="physicianDetails.address.addressLine2">
                        {{ physicianDetails.address.addressLine2 }},
                    </span>
                    <span class="me-1">{{ physicianDetails.address.city }},</span>
                    <span class="me-1">{{ physicianDetails.address.state }}</span>
                    <span class="me-1">{{ formatZipCode(physicianDetails.address.zipCode) }}</span>
                </span>
                <span v-if="physicianDetails.phoneNumbers.length">
                    <strong>Phone:</strong>
                    <template v-if="!!primaryPhoneNumber.number">
                        {{ formatPhoneNumber(primaryPhoneNumber.number) }}
                        <template v-if="!!primaryPhoneNumber.extension">
                            Extn: {{ primaryPhoneNumber.extension }}</template
                        >
                    </template>
                    <i v-else class="text-default">Not Available</i>
                    <template v-if="alternatePhoneNumber && alternatePhoneNumber.number">
                        , {{ formatPhoneNumber(alternatePhoneNumber.number) }}
                        <template v-if="!!alternatePhoneNumber.extension">
                            Extn: {{ alternatePhoneNumber.extension }}</template
                        >
                    </template>
                </span>
                <span>
                    <strong>Fax:</strong>
                    <template v-if="!!physicianDetails.faxNumber">{{
                        formatPhoneNumber(physicianDetails.faxNumber)
                    }}</template>
                    <i v-else class="text-default">Not Available</i>
                </span>
                <span v-if="physicianDetails.email"> {{ physicianDetails.email }} </span>
            </div>
        </section>
    </div>
</template>
<style src="./PatientPhysician.scss"></style>
<script lang="ts" src="./PatientPhysician.ts"></script>
